<template>
  <!-- Header -->
  <div class="admin-header relative">
    <div class="px-4 md:px-6 mx-auto w-full">
      <!-- 数据展示block已移除 -->
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderStats"
};
</script>
